// secrets.js is gitignored; eslint cannot resolve it locally
// eslint-disable-next-line import/no-unresolved, import/extensions
import secrets from './secrets';

const CURRENT_SERVICE_SUBDOMAIN = 'feedback';
const localHostMaps = {
  'feedback-api': 'https://s3-feedback-api.orangehealth.dev',
  'geomark-api': 'https://s3-geomark-api.orangehealth.dev',
  'scheduler-api': 'https://stag5-scheduler-api.orangehealth.dev',
  'oms-api': 'http://localhost:8080',
  'partner-order': 'https://stag2-partner-web-order.orangehealth.dev',
};

export const getHost = (serviceName) => {
  if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
    return localHostMaps[serviceName];
  }
  return window.location.origin.replace(CURRENT_SERVICE_SUBDOMAIN, serviceName);
};

export const config = () => ({
  apiHost: getHost('feedback-api'),
});

export const geomarkConfig = () => ({
  geomarkApiUrl: getHost('geomark-api'),
  geomarkApiKey: secrets.geomarkApiKey,
  mapId: secrets.geomarkGmapsId,
  gmapKey: secrets.geomarkGmapsKey,
});

export const documentConfig = () => ({
  apiHost: getHost('oms-api'),
});

export const omsWebConfig = () => getHost('oms');
export const webUrlConfig = () => getHost('partner-order');
export const MixpanelConfig = () => secrets.mixpanelKey;

export function ExotelNumbersArray() {
  if (typeof secrets.exotelNumbers === 'string') {
    return secrets.exotelNumbers;
  }
  return secrets.exotelNumbers[Math.floor(Math.random() * secrets.exotelNumbers.length)];
}

export const StrichConfig = () => secrets.strichKey;
